import {useParams, useLocation} from 'react-router-dom';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import {isAccountExcludedFromSystemMessagePopup} from '../../../../../functions/customSystemPixel/customSystemPixel';

export const shouldDisplaySystemMessage = (
    message: TSystemMessage,
    pathname: string,
    page?: string,
    eid?: string,
    pid?: string
): boolean => {
    // Exclude specific accounts from seeing the popup
    if(pid && isAccountExcludedFromSystemMessagePopup(pid)) {
        return false;
    }

    const messageScope = message.distributionScope || 'event';
    
    if(messageScope === 'all') {
        return true;
    }

    if(!message.distributionPage) {
        return pathname.includes('/realtime');
    }
    
    const currentScope = eid ? 'event' : pid ? 'account' : null;

    if(messageScope && currentScope !== messageScope) {
        return false;
    }

    return page === message.distributionPage;
};

export const useSystemMessageFilter = (message: TSystemMessage): boolean => {
    const {page, eid, pid} = useParams();
    const location = useLocation();
    
    return shouldDisplaySystemMessage(message, location.pathname, page, eid, pid);
};
